import { NotificationsTransaction } from "@/domains/notifications/constants/notificationsTransaction";
import { NotificationsTransactionType } from "@/domains/notifications/constants/notificationsTransactionType";

export const notificationsTransactionList: Record<
  NotificationsTransactionType,
  NotificationsTransaction
> = {
  [NotificationsTransactionType.SalaryAdded]: {
    image: "/svg/notifications-transaction/sber.svg",
    isIncrement: true,
  },
  [NotificationsTransactionType.Spent]: {
    image: "/svg/notifications-transaction/money.svg",
    isIncrement: false,
  },
  [NotificationsTransactionType.Increment]: {
    image: "/svg/notifications-transaction/money.svg",
    isIncrement: true,
  },
  [NotificationsTransactionType.Decrement]: {
    image: "/svg/notifications-transaction/money.svg",
    isIncrement: false,
  },
};
